import React from "react"

interface AuthLayoutProps {
  isVisible: boolean
  children: React.ReactNode
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ isVisible, children }) => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">

      {/* Background dots */}
      <div
        className="pointer-events-none fixed inset-0 opacity-[0.025]"
        style={{
          backgroundImage: "radial-gradient(#0F52BA 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />

      <div
        className={`w-full max-w-[900px] transition-all duration-500 ease-out
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}
      >
        {children}
      </div>
    </div>
  )
}

export default AuthLayout